<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Customers Reports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {PageHeader, Layout},
name: "customers",
  data() {
    return {
      title: "Customers Reports",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Customers Reports",
          active: true
        }
      ],
    }
  }
}
</script>

<style scoped>

</style>
